var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub_tab"
  }, [_c('ul', {
    staticClass: "sub_tab_menu"
  }, [_vm._l(_vm.links, function (item, i) {
    return [_c('li', {
      key: i,
      class: [_vm.$route.path == `/introduce/${item.url}` ? 'on' : ''],
      on: {
        "click": function ($event) {
          _vm.showLnb = item;
        },
        "mouseenter": function ($event) {
          _vm.showLnb = item;
        },
        "mouseover": function ($event) {
          _vm.showLnb = item;
        },
        "mouseleave": function ($event) {
          _vm.showLnb = null;
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": `/introduce/${item.url}`
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1)];
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }